<template>
    <div>
        <v-layout row wrap>
            <v-flex xs12 my-1 v-for="item in items" :key="item.id">
                <v-card
                class="elevation-5"
                >
                    <v-card-title>
                        <v-layout column fill-height class=" ">
                            <v-flex shrink>
                                <div class="headline primary lighten-5 text-xs-center">{{ item.name }}</div>
                            </v-flex>
                        </v-layout>

                    </v-card-title>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-flex xs12 sm6>
                                <!-- <v-layout row>
                                    <v-flex xs-12 text-xs-center subheading>Sales Rep. Information</v-flex>
                                </v-layout> -->
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Company</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.company }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Address</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>
                                        <div>
                                            {{ item.address }}
                                        </div>
                                        <div>
                                            {{ item.city }},
                                            {{ item.state }} 
                                            {{ item.zip }}
                                        </div>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Phone</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.phone }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Email</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.email }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Start Date</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.startDate}}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>End Date</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.endDate }}</v-flex>
                                </v-layout>
                            </v-flex>
                            <v-flex xs12 sm6>
                                <!-- <v-layout row>
                                    <v-flex xs-12 text-xs-center subheading>Sales Rep. Information</v-flex>
                                </v-layout> -->
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Territory</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.territoryId }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>Territory Type</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.territoryType }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>ZIP Code</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.zipZip  }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>ZIP Code City</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.zipCity }}</v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs4 body-2 pt-1>ZIP Code State</v-flex>
                                    <v-flex xs8 text-xs-left pt-1>{{ item.zipState }}</v-flex>
                                </v-layout>

                            </v-flex>
                        </v-layout>
                    </v-card-text>

                </v-card>
            </v-flex>
        </v-layout>

        <!-- {{items}} -->
    </div>
</template>
<script>
// import _ from "lodash"
import ctlItemAdvancedSearchFilter from '@/components/ctlItemAdvancedSearchFilter'
import { mapActions } from 'vuex'

export default {
    props: ['items'],
    components: {
        'ctlItemAdvancedSearchFilter':ctlItemAdvancedSearchFilter
    },
    data () {
        return {
        }
    },
    computed: {
    },
    methods: {
    },
    watch: {
    }
}
</script>
